import {graphql} from 'react-relay';
import type {ticketingPerson_person$data} from './__generated__/ticketingPerson_person.graphql';

export const ticketingPersonFragment = graphql`
	fragment ticketingPerson_person on Person {
		id
		firstName
		lastName
		fullName
		initials
		profilePictureId
		active
	}
`;

export function personDisplayName(person: Pick<ticketingPerson_person$data, 'fullName' | 'active'> | null | undefined): string {
	if (!person) return 'Unassigned';
	return person.fullName ?? 'Deleted user';
}
